import React from 'react';
import { Terminal, FileText, Pencil, Search, Globe, Bot, Wrench, Check, X, Loader2, ChevronRight } from 'lucide-react';
import { toolMeta, toolInputText } from './chatHelpers';
import CopyButton from './CopyButton';

const ICONS = { terminal: Terminal, file: FileText, edit: Pencil, search: Search, web: Globe, agent: Bot, other: Wrench };

// Compact collapsible chip for one tool call. Expanded: the full input and the output, each in a
// horizontally scrolling monospace box with its own copy button. All plain text.
export default function ToolChip({ item }) {
  const meta = toolMeta(item.name, item.input, item.done);
  const Icon = ICONS[meta.kind] || Wrench;
  const state = !item.done ? 'run' : item.isError ? 'err' : 'ok';
  const input = toolInputText(item.input);
  const output = item.output || (item.done ? '(no output)' : '(no output yet)');
  return (
    <details className={`cc-tool cc-tool-${state}`}>
      <summary className="cc-tool-summary">
        <ChevronRight size={14} className="cc-tool-caret" />
        <Icon size={15} className="cc-tool-icon" />
        <span className="cc-tool-label">{meta.label}</span>
        <span className="cc-tool-state" aria-label={state === 'run' ? 'running' : state === 'err' ? 'failed' : 'done'}>
          {state === 'run' ? <Loader2 size={14} className="cc-spin" /> : state === 'err' ? <X size={14} /> : <Check size={14} />}
        </span>
      </summary>
      {input && (
        <>
          <div className="cc-tool-head"><span>{meta.kind === 'terminal' ? 'Command' : 'Input'}</span><CopyButton text={input} /></div>
          <pre className="cc-tool-input">{input}</pre>
        </>
      )}
      <div className="cc-tool-head"><span>{state === 'err' ? 'Error output' : 'Output'}</span>{item.output ? <CopyButton text={item.output} /> : null}</div>
      <pre className="cc-tool-output">{output}</pre>
    </details>
  );
}
